<template>
  <div>
    <!--网站更新日志  -->
    <baseBreadcrumb :page="$t('message.websiteUpdateLogs')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <!-- 状态筛选 -->
      <div class="tabs">
        <el-tabs v-model="datas.platform" type="card" @tab-click="releaseList">

          <el-tab-pane :label="item.label" :name="item.value" v-for="item in typeList" :key="item.value">
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="btn">
        <!-- 新增 -->
        <el-button type="primary" size="small" @click="add" v-if="isAuth(537)">{{ $t("message.add") }}</el-button>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- NO -->
          <el-table-column align="center" label="NO" prop="rowNumber" width="80">
          </el-table-column>
          <!-- 更新时间 -->
          <el-table-column align="center" :label="$t('message.updateTime')" prop="release_date" width="150">
          </el-table-column>
          <!-- 版本号 -->
          <el-table-column align="center" :label="$t('message.versionNumber')" prop="version" width="150">
          </el-table-column>
          <!-- 更新内容 -->
          <el-table-column align="center" :label="$t('message.updateContent')" prop="rowNumber">
            <template slot-scope="scope">
              <div v-html="scope.row.description" class="description"></div>

            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="150">
            <template slot-scope="scope">
              <!-- 修改 -->
              <el-button size="mini" type="success" @click="edit(scope.row)" v-if="isAuth(538)">{{ $t("message.edit")
                }}</el-button>
              <!-- 删除 -->
              <el-button size="mini" type="success" @click="releaseDestroy(scope.row.id)" class="dark"
                v-if="isAuth(539)">{{ $t("message.delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 新增 修改-->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="addDialogVisible" width="1400px" center>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
          <!-- 端口： -->
          <el-form-item :label="$t('message.port')" prop="platform">
            <el-select v-model="ruleForm.platform" :placeholder="$t('message.versionNumber')">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 版本号： -->
          <el-form-item :label="$t('message.versionNumber')" prop="version">
            <el-input v-model="ruleForm.version"></el-input>
          </el-form-item>
          <!-- 发版日期 -->
          <el-form-item :label="$t('message.releaseDate')" prop="release_date">
            <el-date-picker v-model="ruleForm.release_date" type="date" :placeholder="$t('message.releaseDate')"
              value-format="yyyy-MM-dd ">
            </el-date-picker>
          </el-form-item>
          <!-- 更新内容： -->
          <el-form-item :label="$t('message.updateContent')" prop="description">
            <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.description" :options="quillOption">
            </quill-editor>


          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="addDialogVisible = false">{{ $t("message.cancel") }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="releaseStore" v-if="isAdd">{{ $t("message.save") }}</el-button>
        <!-- 修改 -->
        <el-button type="primary" @click="releaseUpdate" v-else>{{ $t("message.edit") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
export default {

  components: {
    quillEditor,
  },
  data() {
    return {
      quillOption: quillConfig,
      datas: { platform: 'ADMIN', page: 1, pageSize: 10 },
      typeList: [],
      tableData: [],
      addDialogVisible: false,
      isAdd: false,
      ruleForm: { platform: '', version: '', release_date: '', description: '' },
      rules: {
        platform: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        version: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        release_date: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],

      },
      title: "",
      total: 0,

    };
  },
  created() {
    this.$api.siteConfiguration.platformList().then(res => {
      this.typeList = res.data
    })
    this.releaseList();
  },
  methods: {
    releaseList() {
      this.$api.siteConfiguration.releaseList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total
      });
    },
    // 新增
    add() {
      this.title = this.$t("message.add");
      this.ruleForm = {
        platform: 'ADMIN', version: '', release_date: '', description: ''
      };
      this.addDialogVisible = true;
      this.isAdd = true;
    },
    // 新增option
    releaseStore() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration.releaseStore(this.ruleForm).then((res) => {
            if (res.code != 0) return this.$message(res.msg);
            this.addDialogVisible = false;
            this.releaseList();
          });
        }
      });
    },
    // 显示修改
    edit(item) {
      console.log(item);
      this.ruleForm = JSON.parse(JSON.stringify(item));
      this.addDialogVisible = true;
      this.isAdd = false;
      this.title = this.$t("message.edit");
    },
    // 修改
    releaseUpdate() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration
            .releaseUpdate(this.ruleForm)
            .then((res) => {
              if (res.code != 0) return this.$message(res.msg);
              this.addDialogVisible = false;
              this.releaseList();
            });
        }
      });
    },
    // 删除
    releaseDestroy(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration.releaseDestroy({ id }).then((res) => {
            this.$message.success(res.msg);
            this.r
            eleaseList();
          });
        })
        .catch(() => { });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.releaseList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.releaseList();
    },
  },
};
</script>
<style lang='scss' scoped>
.btn {
  text-align: right;
  margin-bottom: 20px;
}

.form {
  padding: 0 20px;
}

.description {
  max-height: 300px;
  overflow-y: auto;
  text-align: left;
}

/deep/.el-select,
.el-date-editor {
  width: 100%;
}

/deep/.ql-editor {
  height: 300px !important;
}
</style>